import Reveal from '@/components/base/Reveal';
import { BrandMark } from '@/components/feature/BrandLogo';
import { logoRules } from '@/mocks/brand';

const variants = [
  {
    key: 'principal',
    label: 'Version principale',
    caption: 'Fond papier — usage par défaut',
    frame: 'bg-background-50 border border-foreground-950/10',
    markSize: 56,
    inverse: false,
    tagline: 'Marine + orange',
  },
  {
    key: 'sombre',
    label: 'Sur fond sombre',
    caption: 'Tuile en réserve claire, lettre marine',
    frame: 'bg-primary-950 border border-primary-900',
    markSize: 56,
    inverse: true,
    tagline: 'Réserve claire',
  },
  {
    key: 'compact',
    label: 'Version compacte',
    caption: 'Barre de navigation et petits formats',
    frame: 'bg-background-50 border border-foreground-950/10',
    markSize: 34,
    inverse: false,
    tagline: '34 px',
  },
  {
    key: 'favicon',
    label: 'Favicon',
    caption: 'Lecture du « S » seul à 32 px',
    frame: 'bg-secondary-100 border border-secondary-200',
    markSize: 32,
    inverse: false,
    tagline: '32 px',
  },
];

export default function LogoSystem() {
  return (
    <section
      id="logo"
      className="relative scroll-mt-32 overflow-hidden border-t border-foreground-950/10 bg-background-100 py-16 md:py-24"
    >
      <div className="pointer-events-none absolute inset-0 paper-grid opacity-60" />
      <div className="container-wide relative">
        <div className="grid gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16">
          <Reveal>
            <div className="flex items-center gap-3">
              <span className="h-px w-8 bg-accent-500" />
              <span className="label-mono text-primary-600">01 — Le logo</span>
            </div>
            <h2 className="display-title mt-5 text-4xl text-foreground-950 md:text-5xl">
              Un bloc-marque
              <br />
              qui ne bouge plus
            </h2>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-foreground-700">
              Le bloc-marque est construit sur trois éléments simples : une tuile bleu marine, le
              « S » de SGSCTIC en Barlow Condensed, et un coin orange industriel. Aucun effet, aucune
              ombre, aucune déformation : il reste net du favicon à la bâche de chantier.
            </p>
            <div className="mt-7 inline-flex items-center gap-3 rounded-md border border-primary-200 bg-background-50 px-4 py-3">
              <i className="ri-lock-2-line text-primary-600" />
              <p className="text-xs font-medium leading-snug text-primary-900">
                Dessin verrouillé — aucune déclinaison ne modifie les proportions.
              </p>
            </div>
          </Reveal>

          <Reveal delay={100}>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {variants.map((variant) => (
                <div key={variant.key}>
                  <div
                    className={`relative flex h-[132px] items-center justify-center overflow-hidden rounded-lg ${variant.frame}`}
                  >
                    <div className="pointer-events-none absolute inset-0 paper-grid opacity-40" />
                    <BrandMark size={variant.markSize} inverse={variant.inverse} className="relative" />
                  </div>
                  <p className="mt-3 font-heading text-base font-semibold uppercase tracking-wide text-foreground-950">
                    {variant.label}
                  </p>
                  <p className="mt-0.5 text-xs text-foreground-500">{variant.caption}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>

        <div className="mt-12 grid gap-px overflow-hidden rounded-lg bg-foreground-950/10 sm:grid-cols-2 lg:grid-cols-4">
          {logoRules.map((rule, index) => (
            <Reveal key={rule.title} delay={index * 70} className="bg-background-50">
              <div className="h-full p-6">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-primary-700">
                  <i className={`${rule.icon} text-base`} />
                </span>
                <h3 className="mt-4 font-heading text-lg font-semibold uppercase leading-tight text-foreground-950">
                  {rule.title}
                </h3>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600">{rule.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}